import { type FC } from 'react';

interface DictationMicIconProps {
  uniqueId?: string;
}

export const DictationMicIcon: FC<DictationMicIconProps> = ({
  uniqueId = `dictation-mic-filter-${Math.random().toString(36).substring(2, 9)}`,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={`url(#${uniqueId})`}>
        <path
          d="M3 6C3 3.79086 4.79086 2 7 2H19C21.2091 2 23 3.79086 23 6V18C23 20.2091 21.2091 22 19 22H7C4.79086 22 3 20.2091 3 18V6Z"
          fill="#EF4444"
          shapeRendering="crispEdges"
        />
        <path
          d="M16.5 11V12C16.5 12.9283 16.1313 13.8185 15.4749 14.4749C14.8185 15.1313 13.9283 15.5 13 15.5M13 15.5C12.0717 15.5 11.1815 15.1313 10.5251 14.4749C9.86875 13.8185 9.5 12.9283 9.5 12V11M13 15.5V17M13 7C12.6022 7 12.2206 7.15804 11.9393 7.43934C11.658 7.72064 11.5 8.10218 11.5 8.5V12C11.5 12.3978 11.658 12.7794 11.9393 13.0607C12.2206 13.342 12.6022 13.5 13 13.5C13.3978 13.5 13.7794 13.342 14.0607 13.0607C14.342 12.7794 14.5 12.3978 14.5 12V8.5C14.5 8.10218 14.342 7.72064 14.0607 7.43934C13.7794 7.15804 13.3978 7 13 7Z"
          stroke="#FAFAFA"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id={uniqueId}
          x="0"
          y="0"
          width="26"
          height="26"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_32907_13518"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_32907_13518"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_32907_13518"
            result="effect2_dropShadow_32907_13518"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_32907_13518"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
